<template>
  <div class="common-container">
    <div id="blurb" class="blurb">
      <div class="title">公司简介</div>
      <div class="content">
        <div class="c-name">快测检测认证网</div>
        <div class="c-desc" v-html="blurb.content"></div>
        <el-carousel trigger="click" height="468px">
          <el-carousel-item v-for="item in blurb.banner" :key="item">
            <el-image :src="item"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div id="grow" class="grow">
      <div class="title">发展历程</div>
      <div class="content" @mouseenter="growAutoScrollState = false" @click="growAutoScrollState = !growAutoScrollState" @mouseleave="growAutoScrollState = true">
        <div class="line"></div>
        <div class="c-main" id="step">
          <div class="cm-item" v-for="(v,i) in growList" :key="i">
            <div class="year">
              <span>{{ v.year }}</span>
              <el-image :src="require('@/assets/about/dot1.png')"></el-image>
            </div>
            <div class="v-line v-line1"></div>
            <div class="cmi-content">
              <div class="cmic-item" v-for="(m,n) in v.children" :key="n">
                <div class="v-line v-line2"></div>
                <div class="cmici-content" :style="n === v.children.length - 1?'padding-bottom:20px':''">
                  <div class="month">
                    <span>{{ m.month }}</span>
                    <el-image :src="require('@/assets/about/dot2.png')"></el-image>
                  </div>
                  <div class="v-line v-line3" v-if="n !== v.children.length - 1"></div>
                  <div class="desc" :style="n !== v.children.length - 1?'margin-left:20px':''">{{ m.desc }}</div>
                </div>
                <div class="v-line v-line2" v-if="n !== v.children.length - 1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="advantage" class="advantage">
      <div class="title">我们的优势</div>
      <div class="content">
        <el-image v-for="(v,i) in advantageList" :key="i" :src="v.image"></el-image>
      </div>
    </div>
    <div id="honor" class="honor">
      <div class="title">荣誉资质</div>
      <div class="content">
        <el-carousel :autoplay="false" height="480px" :loop="false" indicator-position="none" ref="honorCarousel">
          <el-carousel-item v-for="(v,i) in honorList" :key="i">
            <div class="c-main" v-for="(m,n) in v" :key="n">
              <el-image :src="m.image"></el-image>
              <div class="cm-name">{{ m.name }}</div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="btn-group">
          <div class="prev" @click="$refs.honorCarousel.prev()">
            <i class="el-icon-arrow-left"></i>
          </div>
          <div class="next" @click="$refs.honorCarousel.next()">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
    <div id="contact" class="contact">
      <div class="title">联系我们</div>
      <div class="content">
        <div class="c-left">
          <el-image :src="require('@/assets/about/logo.png')"></el-image>
          <div class="line"></div>
          <div class="cl-main">
            <div class="clm-item">用户服务热线：<span>{{ websiteConfig.zipCode }}</span></div>
            <div class="clm-item">机构合作热线：<span>{{ websiteConfig.customerServicePhone }}</span></div>
            <div class="clm-item">意见反馈邮箱：<span>{{ websiteConfig.companyEmail }}</span></div>
            <div class="clm-item">运营中心地址：<span>{{ websiteConfig.companyAddress }}</span></div>
            <div class="clm-item">快测检测认证网：<span>{{ websiteConfig.site }}</span></div>
          </div>
        </div>
        <div class="c-right">
          <div class="cr-title">请添加专属客服微信</div>
          <div class="line"></div>
          <div class="cr-main">
            <el-image :src="websiteConfig.mpImage"></el-image>
            <div class="crm-name">业务咨询·商务合作</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getWebsiteConfig } from "@/utils/website-config";

export default {
  name: "About",
  data () {
    return {
      blurb: {},
      growList: [],
      advantageList: [],
      honorList: [],
      growAutoScrollState: true,
      lastScrollLeft: 0
    }
  },
  computed: {
    websiteConfig () {
      return getWebsiteConfig()
    }
  },
  created () {
    this.getBlurb()
    this.getGrowList()
    this.getAdvantageList()
    this.getHonorList()
  },
  mounted () {
    this.autoScroll()
  },
  methods: {
    /**
     * 荣誉资质
     */
    getHonorList () {
      this.$request.get('/About/honor')
          .then(res => {
            if (res.code === 0) {
              for (let i = 0; i < Math.ceil(res.data.length / 8); i++) {
                this.honorList.push(res.data.slice(i * 8, i * 8 + 8))
              }
            }
          })
    },
    /**
     * 我们的优势
     */
    getAdvantageList () {
      this.$request.get('/About/advantage')
          .then(res => {
            if (res.code === 0) {
              this.advantageList = res.data
            }
          })
    },
    /**
     * 获取公司简介
     */
    getBlurb () {
      this.$request.get('/About/blurb')
          .then(res => {
            if (res.code === 0) {
              this.blurb = res.data
            }
          })
    },
    /**
     * 获取发展历程
     */
    getGrowList () {
      this.$request.get('/About/grow')
          .then(res => {
            if (res.code === 0) {
              this.growList = res.data
            }
          })
    },
    //发展历程自动滚动
    autoScroll () {
      let box = document.getElementById('step');
      let type = true;
      setInterval(() => {
        if(!this.growAutoScrollState) return false;
        let left = box.scrollLeft;
        if(type === true && box.scrollLeft < this.lastScrollLeft) {
          type = false;
        }
        if(type === false && box.scrollLeft > this.lastScrollLeft) {
          type = true;
        }
        if (type) {
          box.scrollLeft += 1;
        } else {
          box.scrollLeft -= 1;
        }
        this.lastScrollLeft = box.scrollLeft;
        if (box.scrollLeft === left) {
          type = !type;
        }
      }, 10);
    },
  }
}
</script>

<style scoped lang="scss">
.title {
  color: #2D2D2D;
  font-size: 38px;
  font-weight: bold;
  margin-bottom: 30px;
}

.blurb, .grow, .advantage, .honor, .contact {
  width: 100%;
  padding: 60px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.blurb, .advantage, .honor {
  background-color: #FFFFFF;
}

.blurb {
  padding: 30px 0 60px 0;

  .content {
    width: 1200px;
    display: flex;
    flex-direction: column;

    .c-name {
      color: #1464FF;
      font-size: 24px;
      font-weight: bold;
    }

    .c-desc {
      font-size: 14px;
      color: #6C6C6C;
      font-weight: bold;
      margin-top: 20px;
      white-space: break-spaces;
    }

    ::v-deep {
      .el-carousel {
        margin-top: 25px;
        border-radius: 4px;
        overflow: hidden;

        .el-carousel__container {
          width: 1200px;
        }
      }
    }
  }
}

.advantage {
  .content {
    width: 1200px;
    margin-top: 25px;
    display: grid;
    grid-template-columns:repeat(2, 1fr);
    gap: 50px;
    justify-items: center;

    .el-image {
      width: 560px;
      height: 180px;
    }
  }
}

.contact {
  .content {
    width: 1200px;
    margin-top: 25px;
    height: 474px;
    background-color: #FFFFFF;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .line {
      width: 20px;
      height: 1px;
      background-color: #A4A4A4;
    }

    .c-left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      padding: 48px 0 70px 48px;

      .el-image {
        width: 280px;
        height: 70px;
      }

      .cl-main {
        display: flex;
        flex-direction: column;

        .clm-item {
          font-size: 14px;
          color: #6C6C6C;
          margin-top: 16px;

          &:first-child {
            margin-top: 0;
          }

          span {
            color: #2D2D2D;
            font-weight: bold;
          }
        }
      }
    }

    .c-right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      padding: 70px 93px 72px 0;

      .cr-title {
        color: #2D2D2D;
        font-weight: bold;
        font-size: 18px;
      }

      .cr-main {
        display: flex;
        flex-direction: row;
        align-items: center;

        .el-image {
          width: 164px;
          height: 164px;
          border-radius: 8px;
          border: 8px solid #1464FF;
        }

        .crm-name {
          color: #000000;
          font-size: 14px;
          font-weight: bold;
          margin-left: 20px;
        }
      }
    }
  }
}

.honor {
  .content {
    width: 1200px;
    margin-top: 25px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .c-main {
      display: flex;
      flex-direction: column;
      align-items: center;

      .el-image {
        width: 248px;
        height: 172px;
      }

      .cm-name {
        color: #000000;
        font-weight: bold;
        font-size: 14px;
        margin-top: 10px;
        padding: 0 20px;
        text-align: center;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .btn-group {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 35px;

      .prev {
        margin-right: 30px;
      }

      .next {
        margin-left: 30px;
      }

      .prev, .next {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background-color: #F1F5FF;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        i {
          font-size: 26px;
          color: #6C6C6C;
        }
      }
    }

    ::v-deep {
      .el-carousel {
        width: 100%;
        height: 480px;

        .el-carousel__item {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
        }

        .el-carousel__arrow {
          display: none;
        }
      }
    }
  }
}

.grow {
  .content {
    position: relative;
    width: 100%;
    margin-top: 25px;
    display: flex;
    flex-direction: column;

    .line {
      position: absolute;
      width: 100%;
      height: 2px;
      background-color: #D6E0F8;
      left: 0;
      top: 57px;
    }

    .c-main {
      width: 100%;
      z-index: 3;
      white-space: nowrap;
      overflow-x: auto;
      padding-bottom: 100px;

      .cm-item {
        display: inline-block;
        width: 402px;
        margin-right: 64px;

        &:first-child {
          margin-left: 150px;
        }

        &:last-child {
          margin-right: 150px;
        }

        .v-line {
          background-color: #1464FF;
          width: 2px;
        }

        .v-line1 {
          height: 40px;
          margin: -8px 0 0 56px;
        }

        .year {
          display: flex;
          flex-direction: column;
          width: fit-content;
          align-items: center;
          margin-left: 21px;

          span {
            color: #1464FF;
            font-size: 32px;
            font-weight: bold;
          }

          .el-image {
            width: 28px;
            height: 28px;
            margin-top: 5px;
          }
        }

        .cmi-content {
          background-color: #F6F9FF;
          width: 100%;
          border-radius: 8px;
          box-shadow: 6px 10px 32px rgba(136, 147, 169, 0.2);
          display: flex;
          flex-direction: column;


          .cmic-item {
            padding: 0 20px;
            display: flex;
            flex-direction: column;
            margin-top: -2px;
            position: relative;

            .v-line2 {
              height: 20px;
              margin-left: 36px;
            }

            .cmici-content {
              display: flex;
              flex-direction: row;

              .month {
                display: flex;
                flex-direction: row;
                align-items: flex-start;

                span {
                  color: #2D2D2D;
                  font-weight: bold;
                  font-size: 16px;
                }

                .el-image {
                  width: 18px;
                  height: 18px;
                  margin-left: 10px;
                }
              }

              .desc {
                margin-left: 10px;
                flex: 1;
                width: 0;
                white-space: normal;
                color: #000000;
                font-weight: bold;
                font-size: 16px;
                display: flex;
                flex-direction: row;
                align-items: flex-start;
              }
            }

            .v-line3 {
              margin-left: -10px;
            }
          }
        }
      }
    }
  }
}
</style>